import { render, staticRenderFns } from "./AutorizarCancelamento.vue?vue&type=template&id=138f29ba&"
import script from "./AutorizarCancelamento.vue?vue&type=script&lang=js&"
export * from "./AutorizarCancelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports